import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import authOnEnter from 'enrollment-platform/authOnEnter'
import PlanManagementV3Gate from './components/PlanManagementV3Gate'
import PlanManagementV3 from './PlanManagementV3'
import { PLAN_MANAGEMENT_V3 } from './paths'

const PlanManagementV3Routes = [
  {
    path: PLAN_MANAGEMENT_V3,
    component: PlanManagementV3Gate,
    onEnter(_nextState, _replace, callback) {
      authOnEnter({
        allowedRoles: [ROLE_PLATFORM_HIXME_ADMIN],
        callback,
      })
    },
    indexRoute: {
      component: PlanManagementV3,
    },
  },
]

export default PlanManagementV3Routes
